import {createAsyncThunk, AsyncThunk} from '@reduxjs/toolkit';
import axios, {AxiosError} from 'axios';

import {USER_LOCALSTORAGE_KEY} from '../../../../../../shared/const/localstorage';
import { setErrorById} from '../../../../slice/courses/curses-by/cursesBy';
import {setRedirectUrlTrackingId} from "../../../../slice/courses/courses-response-url/coursesResponseUrl";
import {setNotFoundError} from "features/model/slice/error/errorSlice";

export interface BuyCourseData {
    id: number | undefined;
    firstName: string;
    lastName: string;
    email: string;
    countryId: number | null;
    numberOfLessons: number;
    paymentMethod: string;
}


type BuyCourseThunk = AsyncThunk<any, BuyCourseData, Record<string, never>>;

export const postCursesById: BuyCourseThunk = createAsyncThunk(
    'courses/buyCourse',
    async (buyCourseData, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }

            const {token} = JSON.parse(authToken);

            const requestBody = {
                firstName: buyCourseData.firstName,
                lastName: buyCourseData.lastName,
                email: buyCourseData.email,
                countryId: buyCourseData.countryId,
                numberOfLessons: buyCourseData.numberOfLessons,
                paymentMethod: buyCourseData.paymentMethod,
            };

            const response = await axios.post(`/api/courses/buy/${buyCourseData.id}`, requestBody, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });




            if (!response.data.success) {
                thunkAPI.dispatch(setErrorById(response.data));
            }

            thunkAPI.dispatch(setRedirectUrlTrackingId(response.data))
            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
